import DefaultToggle from './components/DefaultToggle';

export default DefaultToggle;
